import { drawCommand, tickMemoized } from "lib/regl-helpers";
import { ensureExists } from "lib/utils";
import { mat4, mat3 } from "lib/vec-math";
export function createWithModel(regl, prefix, computeModel) {
    const _arr1 = mat4.create();
    const _arr2 = mat3.create();
    const modelKey = `${prefix}Model`;
    const modelViewKey = `${prefix}ModelView`;
    const modelNormalKey = `${prefix}ModelNormal`;
    const getModel = tickMemoized(computeModel);
    const getModelView = tickMemoized((ctx) => {
        return mat4.multiply(_arr1, ensureExists(ctx.view, "Could not find the view matrix"), getModel(ctx));
    });
    return drawCommand(regl, {
        name: "withModel",
        context: {
            [modelKey]: getModel,
            [modelViewKey]: getModelView,
            [modelNormalKey]: (ctx) => {
                const modelView = getModelView(ctx);
                return mat3.normalFromMat4(_arr2, modelView);
            },
        },
    });
}
